/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShiftBidStatus = {
    type: 'Enum',
};